import { useEffect, useRef } from 'react';

export const useIntersectionObserve = (
  ref: React.MutableRefObject<Element | null>,
  callback: () => void,
  options?: IntersectionObserverInit
) => {
  const callbackRef = useRef(callback);
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!ref.current && typeof IntersectionObserver !== 'function') return;

    const handler = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          callbackRef.current();
          observerRef.current?.unobserve(entry.target);
        }
      });
    };

    observerRef.current?.disconnect();

    observerRef.current = new IntersectionObserver(handler, options);
    const currentRef = ref.current;

    if (currentRef) {
      observerRef.current.observe(currentRef);
    }

    return () => {
      observerRef.current?.disconnect();
    };
  }, [options, ref]);
};
